import React, { useState } from 'react';
import ActionsDropdown from 'components/common/ActionsDropdown';
import * as Routes from 'modules/routes';
import DropdownLink from './DropdownLink';
import DropDownButton from './DropdownButton';
import UnitNumberModal from './UnitNumberModal';

interface UnitActionsProps {
  programId: number
  unitId: number
  unitProgramLessonId?: number
  unitTitle?: string
  unitNumber?: number
}

const UnitActions = ({ unitId, programId, unitProgramLessonId, unitTitle, unitNumber }: UnitActionsProps) => {
  const [numberModal, setNumberModal] = useState<boolean>(false);

  return (
    <>
      <ActionsDropdown id={`unit_${unitId}`}>
        <DropdownLink
          href={Routes.edit_admin_unit_path(unitId, { program_id: programId })}
          icon="fa-edit"
          text="Edit Unit Lessons"
        />
        <DropDownButton
          callback={() => setNumberModal(true)}
          icon="fa-edit"
          text="Edit Unit Number"
        />
        <div className="dropdown-divider" />
        <DropdownLink
          href={Routes.unit_index_admin_notebooks_path({ program_id: programId, unit_id: unitId })}
          icon="fa-eye"
          text="See Unit Projects"
        />
        <DropdownLink
          href={Routes.admin_unit_unit_project_materials_path(unitId, { program_id: programId })}
          icon="fa-eye"
          text="See Unit Materials"
        />
        <DropdownLink
          href={Routes.admin_unit_sections_path(unitId, { program_id: programId })}
          icon="fa-eye"
          text="See Unit Sections"
        />
        <DropdownLink
          href={Routes.unit_index_admin_unit_slide_shows_path(unitId, { program_id: programId })}
          icon="fa-eye"
          text="See Unit Slideshows"
        />
      </ActionsDropdown>
      <UnitNumberModal
        close={() => setNumberModal(false)}
        isOpen={numberModal}
        unitNumber={unitNumber}
        unitProgramLessonId={unitProgramLessonId}
        unitTitle={unitTitle}
      />
    </>
  );
};

export default UnitActions;
